<template>
  <div class="__DevTools-General">
    <!-- Language -->
    <CSection>
      <CTitle margin-bottom>Language</CTitle>
      <CSelector
        v-model="currentLocale"
        :options="localOptions"
        map-options
        emit-value
        :disabled="disabled"
        :use-input="false"
        hide-bottom-space
      />
    </CSection>

    <CSeparator spaced />

    <!-- Port -->
    <CSection>
      <CTitle margin-bottom>Port</CTitle>
      <CRow gutter="sm">
        <CCol col="6">
          <CInputNumber label="RBAC" v-model="rbacPort" hide-bottom-space />
        </CCol>
        <CCol col="6">
          <CInputNumber label="Invoice" v-model="invoicePort" hide-bottom-space />
        </CCol>
        <CCol col="6">
          <CInputNumber label="Aqua" v-model="aquaPort" hide-bottom-space />
        </CCol>
      </CRow>
    </CSection>

    <CSeparator spaced />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import Config from '@/config';

import CSection from '@/components/uikit/CSection';
import CTitle from '@/components/uikit/CTitle';
import CRow from '@/components/uikit/CRow';
import CCol from '@/components/uikit/CCol';
import CSeparator from '@/components/uikit/CSeparator';
import CSelector from '@/components/uikit/CSelector';
import CInputNumber from '@/components/uikit/CInputNumber';

export default Vue.extend({
  name: 'DevToolLocale',
  components: { CSection, CTitle, CRow, CCol, CSeparator, CSelector, CInputNumber },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      localOptions: [
        { label: 'English', value: 'en' },
        { label: 'Japanese', value: 'ja' },
      ],

      // Ports
      rbacPort: null,
      invoicePort: null,
      aquaPort: null,
    };
  },
  created() {
    const rbacPort = Cookies.get('rbac_port');
    if (rbacPort) this.rbacPort = rbacPort;

    const invoicePort = Cookies.get('invoice_port');
    if (invoicePort) this.invoicePort = invoicePort;

    const aquaPort = Cookies.get('aqua_port');
    if (aquaPort) this.aquaPort = aquaPort;
  },
  watch: {
    rbacPort(val) {
      Cookies.set('rbac_port', val, { expires: Config.tokenExpire });
    },
    invoicePort(val) {
      Cookies.set('invoice_port', val, { expires: Config.tokenExpire });
    },
    aquaPort(val) {
      Cookies.set('aqua_port', val, { expires: Config.tokenExpire });
    },
  },
  computed: {
    ...mapGetters('devTools', ['getLocale']),

    currentLocale: {
      get() {
        return this.getLocale;
      },
      set(val) {
        this.changeLocale(val);
      },
    },
  },
  methods: {
    ...mapActions('devTools', ['changeLocale']),
  },
});
</script>
